import React from 'react';
import styled from 'styled-components';
import NftMintBanner from "../../Images/NftMintBanner1.jpg";

const Root = styled.div``;
const Container = styled.div``;
const ImageWrapper = styled.div`
display: flex;
justify-content:center;
text-align:center;
align-items:center;
padding-right:10px;
`;
const Image = styled.img`
border-radius:12px;
`;


const BannerNft = () => {
  return (
    <Root>
        <Container>
            <ImageWrapper>
                <Image src={NftMintBanner}>

                </Image>
            </ImageWrapper>
        </Container>
    </Root>
   
  )
}

export default BannerNft